export class ConcentrationUomModel {
    id?: number;
    uomDisplay?: string;
    description?: string;
    isEnabled: boolean;
    sortOrder: number;
}

